const HYBRID_MODE = "hybrid_ecommerce"

/** ASAP / QSR modes — no scheduled date/slot UX. */
const ASAP_DELIVERY_MODES = new Set(["same_day_food", "immediate"])

const SCHEDULED_DELIVERY_LISTING_MODES = new Set([
  "scheduled_ecommerce",
  "hybrid_ecommerce",
  "promise_window",
])

export const isAsapDeliveryProfileMode = (mode = "") =>
  ASAP_DELIVERY_MODES.has(String(mode || "").trim())

/**
 * True when the brand (or tenant cards) use fast-food / QSR ASAP delivery.
 * Used to hide branch cut-off + time-slot fields.
 * Holiday blackout stays permanent; delivery days stay for delivery eligibility.
 */
export const brandUsesAsapDeliveryPattern = (scopeCards = [], brandId = null) => {
  const cards = Array.isArray(scopeCards) ? scopeCards : []
  const normalizedBrandId = String(brandId || "").trim()

  if (normalizedBrandId) {
    const card = cards.find(
      entry => String(entry.brandId) === normalizedBrandId
    )
    if (!card) {
      return false
    }
    return isAsapDeliveryProfileMode(card.mode)
  }

  if (!cards.length) {
    return false
  }

  // No brand selected: treat as ASAP only when every brand is ASAP/QSR.
  return cards.every(entry => isAsapDeliveryProfileMode(entry.mode))
}

export const brandShowsScheduledDeliveryDateInOrders = (brand = null) => {
  const mode = String(brand?.deliveryProfile?.mode || "").trim()
  if (!mode) {
    return false
  }
  return SCHEDULED_DELIVERY_LISTING_MODES.has(mode)
}

export const brandSupportsFastMovingItems = (scopeCards = [], brandId = null) => {
  const cards = Array.isArray(scopeCards) ? scopeCards : []
  const normalizedBrandId = String(brandId || "").trim()

  if (normalizedBrandId) {
    const card = cards.find(
      entry => String(entry.brandId) === normalizedBrandId
    )
    return card?.mode === HYBRID_MODE
  }

  return cards.some(entry => entry.mode === HYBRID_MODE)
}
